import { create } from "zustand";

/**
 * Share Dialog Store
 *
 * Zero Props Pattern: Dialog state management
 * Modal'lar hiç prop almaz, tüm state bu store'dan gelir
 */
interface ShareDialogStore {
  // Dialog State
  isOpen: boolean;
  shareLink: string | null;
  conversationId: string | null;
  isPublic: boolean; // Conversation'ın public olup olmadığı

  // Actions
  openDialog: (conversationId: string, isPublic: boolean) => void;
  setShareLink: (link: string) => void;
  setIsPublic: (isPublic: boolean) => void;
  closeDialog: () => void;
  reset: () => void;
}

const initialState = {
  isOpen: false,
  shareLink: null,
  conversationId: null,
  isPublic: false,
};

export const useShareDialogStore = create<ShareDialogStore>((set) => ({
  ...initialState,

  openDialog: (conversationId, isPublic) =>
    set({
      isOpen: true,
      conversationId,
      isPublic,
      shareLink: null, // Reset shareLink when opening dialog
    }),

  setShareLink: (link) =>
    set({
      shareLink: link,
    }),

  setIsPublic: (isPublic) =>
    set({
      isPublic,
    }),

  closeDialog: () =>
    set({
      isOpen: false,
    }),

  reset: () => set(initialState),
}));
